import React, { PropsWithChildren, useRef } from 'react';
import { Button } from 'antd';
import { useRedirectPath } from '@identity/hooks/use-redirect-path';
import { AuthProviderType } from '@identity/graphql';
import clsx from 'clsx';
import Auth from 'works/legacy/lib/auth';

type Props = {
  authProvider: AuthProviderType;
  membershipId: string;
  fullWidth?: boolean;
  className?: string;
};

export function ProviderButton({
  authProvider,
  children,
  membershipId,
  fullWidth = false,
  className,
}: PropsWithChildren<Props>) {
  const submittalForm = useRef<HTMLFormElement>();
  const redirectPath = useRedirectPath();

  const baseAction = `${authProvider.url}&membership_id=${membershipId}`;

  const action = redirectPath
    ? `${baseAction}&redirect_path=${encodeURIComponent(redirectPath)}`
    : baseAction;

  const onClickSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    Auth.setPendingSsoMembershipId(membershipId);
    submittalForm.current?.submit();
  };

  const csrfTokenMeta = document.querySelector(
    'meta[name=csrf-token]'
  ) as HTMLMetaElement;
  const csrfParamMeta = document.querySelector(
    'meta[name=csrf-param]'
  ) as HTMLMetaElement;

  const csrfToken = csrfTokenMeta && csrfTokenMeta.content;
  const csrfParam = csrfParamMeta && csrfParamMeta.content;

  return (
    <div
      className={clsx('wk-provider-button', className, {
        'wk-provider-button--full-width': fullWidth,
      })}
    >
      {/* eslint-disable-next-line */}
      {/* @ts-ignore: ref can also be used in native elements */}
      <form action={action} method="post" ref={submittalForm}>
        <input name="_method" value="post" type="hidden" />
        {csrfToken && csrfParam && (
          <input name={csrfParam} value={csrfToken} type="hidden" />
        )}
        <Button
          type="primary"
          onClick={onClickSubmit}
          size="large"
          style={{ width: fullWidth ? '100%' : undefined }}
        >
          <span className="sign-in-button-text">{children}</span>
        </Button>
      </form>
      <style jsx global>
        {`
          .provider-button .sign-in-button-text {
            overflow: hidden;
            white-space: nowrap;
            display: block;
            text-overflow: ellipsis;
          }

          .wk-provider-button--full-width {
            width: 100%;
          }
        `}
      </style>
    </div>
  );
}
